module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("I dedicate this book to my paternal relations,")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("Hardys, Baileys and Ostcliffes,")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("who laboured in the coal mines of the West Riding of Yorkshire.")]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_vm._v("In remembrance of all mineworkers throughout the ages, especially victims of colliery disasters or accidents.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("Barnsley, like many places, was built on their blood, sweat and tears.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sculpture by Graham Ibbeson at the National Union of Mineworkers Offices.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbf73d32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Ded.vue
// module id = 60
// module chunks = 0